ScrollHelper = App.load "core::ScrollHelper"
ValidationEngine = App.loadClass "core::ValidationEngine"

class exports.Layer_Prescription_Map_Dialog extends DialogHandler

    is_export: false

    init: () ->

        @loadLayoutPostOptions ?= {}

        @layoutUrl      = 'backend/grower/layers/prescription-map/load-layout'
        @classes        = 'large_dialog'
        @submitBindings = true


        if @is_export
            @loadLayoutPostOptions.hybrids_id = @export_params.hybrids_id

        if @loadLayoutPostOptions.id?
            @newLayer   = false
            @saveUrl    = 'backend/grower/layers/prescription-map/update'
        else
            @newLayer   = true
            @saveUrl    = 'backend/grower/layers/prescription-map/add'


        ###
        This is stupid and overcomplicated. Basically, soils needs to be displayed before
        we load the dialog, because DISPLAYING SOILS creates the user soil colors, which are required
        for prescription maps to display correctly
        ###
        $(window).unbind('Data.Soils.loaded').bind 'Data.Soils.loaded', () =>
            $(window).unbind 'Data.Soils.loaded'
            #if @loadLayoutPostOptions.id is @loadLayoutPostOptions.fields_id
            #    @loadLayoutPostOptions.id = null
            @createDialog()


        soil_obj = $(@parent.layoutSelector).find('[data-layertype="soils"]')
        if soil_obj.length > 0
            if not soil_obj.parents('tr').data('layer_object')?
                soil_obj.parents('td').trigger('click')
            else
                @createDialog()

        else
            if not @is_export
                soil = @createSubHandler 'grower::handlers/data/layers/Layer_Soil'
            if soil?
                soil.loadLayoutPostOptions = $.extend true, {}, @loadLayoutPostOptions
                soil.loadLayoutPostOptions.id = @loadLayoutPostOptions.fields_id
                soil.init()
            else # something went wrong, try creating the dialog anyway
                @createDialog()


        @successAction = () =>
            if not @formKO.layer().layer_name()?
                return false

            if App.sidebar.contentDiv().find("#dataList tr").length > 0
                App.sidebar.contentDiv().find("#dataList tr[data-layer_id='#{@loadLayoutPostOptions.id}'] td")
                    .eq(0)
                    .find('.layer_type')
                    .html("Prescription Map #{@formKO.layer().layer_name()}")

        @validator = new ValidationEngine()


    afterLoadLayout: (selector, response) ->
        @openDialog()

        if response.status?.type isnt 'success'
            return

        @dialog.find('.message_writer').addClass 'absolute-errorDiv'
        @dialog.find('.message_writer').message_writer 'setInitialClass'

        # todo: what is this setTimeout hack supposed to accomplish?
        # Generally using setTimeout is considered a bad thing, unless you
        # actually want something to happen after a certain amount of time.
        # (For instance, opening a popup every 10 seconds would be an annoying
        # but proper use of setTimeout.) But this is just part of loading the
        # dialog, so I would think an event or a callback would be a much
        # better choice.
        # -SK
        setTimeout () =>
            # console.log @dialog.find('.form-container').width()

            ScrollHelper.make @dialog.find('.rx-table'),
                height: 300
                width: "#{@dialog.find('.form-container').width() - 5}"
                footer: true
                forceHeight: true

            @setPosition()
        , 200


        if response.data.prescription_map? and response.data.prescription_map.hybrids_id
            @is_export = true


        if @is_export
            response.data.prescription_map ?= {}
            response.data.prescription_map = $.extend(@export_params, response.data.prescription_map)
            koClass = App.loadClass "grower::viewmodels/prescription_map/export/Form"

        else
            koClass = App.loadClass "grower::viewmodels/prescription_map/Form"

        # Init dat Ko viewmodel!
        @formKO = new koClass this, response.data

        # Tie the viewmodel to the view
        #ko.cleanNode @dialog
        ko.applyBindings @formKO, @dialog[0]

        if @is_export and @newLayer and @formKO.layer().target_population isnt 0
            @formKO.recalcPopulations()

        if @startEditing
            @formKO.setEditing()

        @dialog.find('.hover-yield').tooltip
            title: 'Yield Productivity potential in bushels per acre is estimated by USDA
                when collecting SSURGO Soil data. Values are not representative of modern
                corn yields, but provide a guide for relative soil type performance'
            placement: 'bottom'

        @dialog.find('.hover-soil-type').tooltip
            placement: 'bottom'
            title: 'test'

        #Validation:
        @validator.makeFormValidator 'rx_map', '#frm_rx_map', '#rx_map_errors', (valid) =>
            if valid
                # Perform an action if the form successfully validated
                @save('Saving...')
            else
                # Perform an action if the form validation failed

        @dialog.find('.rx_map-recalc_btn').bind 'click', (e) =>
            @validator.validateForm('rx_map', false)

        @validator.registerRule
            'selector': '.validate-max-pop-gt-min'
            'text': 'Max Pop must be greater than Min Pop'
            'func': (elem) =>
                if not @formKO.layer().max_population()? or not @formKO.layer().min_population()?
                    return true
                if parseInt(@formKO.layer().max_population()) < parseInt(@formKO.layer().min_population())
                    return false
                return true

        @validator.registerRule
            'selector': '.validate-max-diff-gt-min'
            'text': 'Max Pop Diff must be greater than Min Pop Diff'
            'func': (elem) =>
                if not @formKO.layer().max_pop_diff()? or not @formKO.layer().min_pop_diff()?
                    return true
                if parseInt(@formKO.layer().max_pop_diff()) < parseInt(@formKO.layer().min_pop_diff())
                    return false
                return true

        @validator.registerRule
            'selector': '.validate-target-in-range'
            'text': 'Target Population must be between Min and Max Pop'
            'func': (elem) =>
                if @formKO.layer().min_population()? and @formKO.layer().target_population() < @formKO.layer().min_population()
                    return false
                if @formKO.layer().max_population()? and @formKO.layer().target_population() > @formKO.layer().max_population()
                    return false
                return true


    submitAction: () =>
        @validator.validateForm('rx_map')


    getPostData: () ->
        data = "id=" + @loadLayoutPostOptions.id + "&json=" + @formKO.layer().serialize()
        return data


    editLayer: () =>
        @formKO.setEditing()


    destroy: () ->
        soil_obj = $(@parent.layoutSelector).find('[data-layertype="soils"]')
        if soil_obj.parents('tr').data('layer_object')?
            soil_obj.parents('td').trigger('click')

        super()
